import { render, staticRenderFns } from "./agenda_masuk.vue?vue&type=template&id=d52c6f4e&"
import script from "./agenda_masuk.vue?vue&type=script&lang=js&"
export * from "./agenda_masuk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports